import { useUser } from "../contexts/UserProvider";
import ChooseAFile from "./ChooseAFile";
import { ExtendedMarkdown, NewTab, InputInvalidMessage } from "./UtilityComponents";

export default function ResearchSectionContent({
    index,
    oneShowInput,
    updatedItem,
    oneSectionData,
    setUpdatedSectionsData,
    updatedImgFiles,
    setUpdatedImgFiles,
    withImage = true,
    children,
}) {
    const { uid } = useUser();

    const isGuest = uid === 'Guest';

    const updateSection = (patch) => {
        setUpdatedSectionsData(prev => {
            const next = [...prev];
            const current = next[index] || {};
            next[index] = { ...current, ...patch };
            return next;
        });
    };
    const makeFieldChangeHandler = (field, parser = v => v) => (e) => {
        const value = parser(e.target.value);
        updateSection({ [field]: value });
    };
    const handleTitleChange = makeFieldChangeHandler('title');
    const handleTextChange = makeFieldChangeHandler('text');
    const handleSortIndexChange = makeFieldChangeHandler(
        'sortIndex',
        v => (v === '' ? '' : parseInt(v, 10))
    );

    return (
        <>
            {oneShowInput && !isGuest && (
                <>
                    {/* Title input */}
                    <b>Title</b>&nbsp;
                    <InputInvalidMessage condition={updatedItem.title === ''} />
                    <input
                        type="text"
                        placeholder="Title"
                        value={updatedItem.title || ''}
                        onChange={handleTitleChange}
                        style={{ marginTop: '5px', marginBottom: '5px' }}
                    />

                    {/* Content input */}
                    <b>Content</b>&nbsp;
                    <span style={{ fontSize: '0.8em' }}>
                        (Support the <NewTab href='https://www.markdownguide.org'>Markdown</NewTab> syntax.)
                    </span>&nbsp;
                    <InputInvalidMessage condition={updatedItem.text === ''} />
                    <textarea
                        placeholder="Content (Markdown supported. E.g., **bold**, *italic*, [link](url))"
                        value={updatedItem.text || ''}
                        onChange={handleTextChange}
                        style={{ marginTop: '5px', marginBottom: '5px', height: '20em', fontSize: '0.8em' }}
                    />

                    {/* Sort Index selection */}
                    <b>Order</b>&nbsp;
                    <span style={{ fontSize: '0.8em' }}>
                        (Sections with an image are always displayed before those without, regardless of the "Order" value.)
                    </span>
                    <select value={updatedItem.sortIndex || ''}
                        onChange={handleSortIndexChange}
                        style={{ marginTop: '5px', marginBottom: '5px' }}
                    >
                        {children}
                    </select>

                    {/* Image upload */}
                    {withImage && (
                        <>
                            <b>Image</b>&nbsp;
                            <span style={{ fontSize: '0.8em' }}>
                                (Optional. Replace the current one.)
                            </span>
                            <div style={{ marginTop: '5px', marginBottom: '5px' }}>
                                <ChooseAFile
                                    index={index}
                                    accept={'.jpg, .jpeg, .png'} // need a space after comma
                                    files={updatedImgFiles}
                                    setFiles={setUpdatedImgFiles}
                                    alwaysDark={true}
                                />
                            </div> 
                        </>
                    )}
                </>
            )}

            {/* Display content when not editing */}
            {!oneShowInput && (
                <>
                    <h2>{oneSectionData.title}</h2>
                    <ExtendedMarkdown>
                        {oneSectionData.text}
                    </ExtendedMarkdown>
                    {uid !== 'Guest' && (
                        <div style={{ marginTop: '5px', marginBottom: '5px' }}>
                            <b>Order:</b> {oneSectionData.sortIndex}
                        </div>
                    )}
                </>
            )}
        </>
    );
}